// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3_pOS","selects":"Documents_selects__3EkQX"};